import { Component, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TakeUntilDestroy } from '@app/shared/decorators/take-until-destroy.decorator';
import { ChallengeEventType, LimitedTimeEventType } from '@app/shared/models/limitedTimeEvent.model';
import { Modal, ModalConfig, ModalType, NonPersistedModalName } from '@app/shared/models/modal.model';
import { Display, FontSizeRescalerService } from '@app/shared/services/font-rescaler.service';
import { LoggerService } from '@app/shared/services/logger.service';
import { EventManager } from '@app/shared/utils/event-manager';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { DisplayComponent } from '@app/shared/components/display/display.component';
import { NgStyle, UpperCasePipe, DecimalPipe } from '@angular/common';
import { ButtonComponent } from '@app/shared/components/button/button.component';
import { SharedModule } from '@app/shared/shared.module';
import { EventsRepository } from '@app/shared/state/events/events.repository';

@TakeUntilDestroy
@Component({
  selector: 'slotcom-multi-gamechallenges-reward-modal',
  templateUrl: './multi-gamechallenges-reward.component.html',
  styleUrls: ['./multi-gamechallenges-reward.component.scss'],
  standalone: true,
  imports: [DisplayComponent, NgStyle, ButtonComponent, UpperCasePipe, DecimalPipe, TranslateModule, SharedModule],
})
export class MultiChallengesRewardModalComponent implements OnInit {
  multiGameChallengesRewardModalData = inject<ModalConfig>(MAT_DIALOG_DATA);
  private eventManager = inject(EventManager);
  logger = inject(LoggerService);
  private translateService = inject(TranslateService);
  private eventsRepo = inject(EventsRepository);
  private fontSizeRescalerService = inject(FontSizeRescalerService);

  componentDestroy: () => Observable<unknown>;

  ChallengeEventType = ChallengeEventType;
  lang: string;
  isAdventureQuest: boolean;

  ngOnInit(): void {
    this.lang = this.translateService.currentLang;
    this.isAdventureQuest = this.checkIfIsAdventureQuest();
  }

  closeModal(): void {
    this.eventManager.closeModal(
      new Modal(
        this.multiGameChallengesRewardModalData.id,
        ModalType.Persisted,
        this.multiGameChallengesRewardModalData
      )
    );
  }

  openMultiGameChallenges(): void {
    this.closeModal();
    this.eventManager.openModal(
      new Modal(
        NonPersistedModalName.MultiChallengesModalComponent,
        ModalType.View,
        this.eventsRepo.getEventById(this.multiGameChallengesRewardModalData.properties.eventId),
        '',
        true
      )
    );
  }

  setFontSize(): string {
    return this.fontSizeRescalerService.setFontSize(
      Display.LargeDisplay,
      this.multiGameChallengesRewardModalData.reward.credits
    );
  }

  private checkIfIsAdventureQuest(): boolean {
    return this.multiGameChallengesRewardModalData.properties.eventType === LimitedTimeEventType.AdventureQuest;
  }
}
